import { Grid } from '@mui/material';
import { HeadCell } from './data';

const quoteHeadCells: HeadCell[] = [
	{ id: 'insuredName', numeric: false, label: 'Insured name' },
	{ id: 'inceptionDate', numeric: false, label: 'Inception date' },
	{ id: 'modifiedDate', numeric: false, label: 'Last modified' },
	{
		id: 'quotes',
		numeric: false,
		label: 'Product(s)',
		sortable: false,
		colSpan: 2,
		component: (
			<Grid container width={'100%'} alignItems={'center'}>
				<Grid item xs={7} pr='1em'>
					{'Product(s)'}
				</Grid>
				<Grid item xs={4}>{'Status'}</Grid>
			</Grid>
		),
	},
	// { id: 'products', numeric: false, label: 'Product(s)', sortable: false },
	// { id: 'status', numeric: false, label: 'Status', sortable: false },
	{ id: 'id', numeric: false, label: 'Manage', sortable: false },
];

export default quoteHeadCells;
